module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_MT-482da9d9ac7d9902dcae5d4d1f6b7465.svg";